import {isMobile, isMockModeEnabled, showErrorToast, sleep} from "../helpers";
import {showNodeDetails} from "../blocks";
import {mockHistoryDetail} from "./mock";
import {voiceIcons} from "./mic";
import {
  continueChat,
  setChatId,
  setSessionId,
  getChatDetail,
  setIsReviewExposed, resetSessionState
} from "./api";
import {selectChatInHistory, prependDraftChatToHistory, generateHistoryItem} from "./history-sidebar";
import {parseBotResponse} from "./utils";
import { openDrawer, injectDataOnDrawer, closeDrawer } from "../components/drawer";
import { getBannerQaDrawerContent, toggleBtnQaDuringChat } from "../qa";

export const chatContainerSelector = '.chat-container'

// contatori per paginazione chat durante il caricamento di chat vecchie
let currentPage
let totalPages

export function initChatContainer(submitCallback) {

  const $input = jQuery('#chatbot-input')

  $input.on('keyup', function (e) {
    if (e.originalEvent.code === 'Enter') {
      const value = jQuery(this).val();
      if (value) submitCallback(value);
    }
  })

  jQuery('#chatbot-submit').on('click', function () {
    const value = $input.val();
    if (value) submitCallback(value);
  })

  jQuery('body').on('click', '.ref-show-details', function () {
    const drupalId = jQuery(this).data('drupal-id');
    if (!drupalId) return;
    showNodeDetails({nid: drupalId});
  })

  jQuery(chatContainerSelector).on('click', '.chat-load-more', async function () {
    jQuery(this).addClass("pointer-events-none opacity-50")
    jQuery(this).append(`
      <div id="prev-chat-loading-spinner" class="flex items-center size-10">
        <div class="loader-history"></div>
      </div>
    `)
    await loadNextPageChatHistory();
    jQuery(this).parent().remove()
  })
}

export function appendQuestion(message = '', options = {targetContainer: ""}) {
  jQuery('#answer-placeholder').addClass('hidden');
  const template = `
    <div class="bot-question">${message}</div>
  `

  const target = options?.targetContainer || chatContainerSelector

  jQuery(target).append(template)
}

export function appendAnswer(response = {}, options = {printReviewBox: true, targetContainer: ""}) {
  removeAnswerPlaceholder();

  let message = '';
  if (response.message) {
    message = response.message
  }

  let references = '';

  if (response.references && Array.isArray(response.references) && response.references.length > 0) {

    let refLinks = [];
    for (const ref of response.references) {

      let title = '';
      if (ref.title) {
        title = `
          <h4 class="text-black text-lg mb-2 font-medium break-all overflow-hidden">${ref.title}</h4>
        `
      }

      let button = '';
      if (ref.drupal_id) {
        const labelCtaDocument = ref.type === "template" ? "Scarica Modulo" : "Vedi documento"
        button = `
            <button type="button" class="ref-show-details text-pink-400 text-lg font-medium" data-drupal-id="${ref.drupal_id}">
                <span>→ ${labelCtaDocument}</span>
            </button>
        `
      }

      const link = `
        <li class="overflow-hidden w-fit p-3 block">
            ${title}
            ${button}
        </li>
      `
      refLinks.push(link)
    }

    references = `
    <ul class="flex flex-col gap-3 mt-5">
        ${refLinks.join('')}
    </ul>
    `
  }

  let ratingBlock = '';

  if (response.collect_feedback && options.printReviewBox) {
    setIsReviewExposed(true)

    ratingBlock = `
  <div class="bot-rating rounded-xl shadow-button flex flex-col lg:flex-row items-center gap-2 w-fit bg-white">
    <div class="stars flex">
      ${[1, 2, 3, 4, 5].map(num => `
        <span class="star cursor-pointer" data-value="${num}">
          <img src="/themes/custom/adoption_management/assets/icons/star.svg" alt="star">
        </span>
      `).join('')}
    </div>
    <div class="flex items-center">
        <div class="rating-result text-xs hidden lg:block" style="color: #3F4550">Valuta la risposta prima di proseguire</div>
        <div class="rating-result text-xs text-center lg:hidden" style="color: #3F4550">Valuta prima di proseguire</div>
    </div>
  </div>
`;
  }

  //gestione icona text to speech
  const deviceType = isMobile() ? 'mobile' : 'desktop';
  const config = voiceIcons[deviceType];

  const template = `
    <div class="bot-answer">
      <div class="bot-profile-pic">
        <img src="/themes/custom/adoption_management/assets/img/baby-brain.png" alt="">
      </div>
      <div class="response">
        <div class="message break-words">
          ${message}
        </div>

        <div class="references">
          ${references}
        </div>

        <div class="flex gap-2 items-center p-2">
        <button type="button" class="btn-listen-msg shadow-button flex flex-col lg:flex-row border-neutral-a100 border justify-center items-center gap-1 bg-white rounded-xl p-4"
          data-text="${message.replace(/"/g, '&quot;')}" style="min-width:${config.width};height:${config.height}">
          <img class="listen-icon"  src="${config.default}" alt="ascolta">
          <span class="listen-text text-xs">${config.defaultText}</span>
        </button>
        <div class="choices-answer">
        ${ratingBlock}
        </div>
        </div>

      </div>
    </div>
  `;


  const target = options?.targetContainer || chatContainerSelector
  jQuery(target).append(template);

  jQuery('.response a').attr('target', '_blank');


  // Rimuovo SOLO rating non usati
  jQuery('.bot-rating').not('.disabled').not(':last').remove();

  initStarsJquery();
}

export function appendAnswerPlaceholder() {
  const template = `
    <div  class="bot-answer bot-answer-placeholder hidden">
      <div class="bot-profile-pic">
        <img src="/themes/custom/adoption_management/assets/img/baby-brain.png" alt="">
      </div>
      <div class="response pt-3">
        <div id="loader-wrapper">
            <div class="loader"></div>
        </div>
      </div>
    </div>
  `
  jQuery(chatContainerSelector).append(template)
}


export function focusTextInput() {
  if (!isMobile()) jQuery('#chatbot-input').focus()
}

export const initStarsJquery = () => {

  // Prima rimuovo i vecchi handler
  jQuery('body').off('mouseenter', '.bot-rating:not(.disabled) .star');
  jQuery('body').off('mouseleave', '.bot-rating:not(.disabled) .stars');
  jQuery('body').off('click', '.bot-rating:not(.disabled) .star');

  jQuery('body').on('mouseenter', '.bot-rating:not(.disabled) .star', function () {
    const val = jQuery(this).data('value');
    jQuery(this).parent().find('.star').each(function () {
      const thisVal = jQuery(this).data('value');
      const img = jQuery(this).find('img');
      if (thisVal <= val) {
        img.attr('src', '/themes/custom/adoption_management/assets/icons/star-hover.svg');
      } else {
        img.attr('src', '/themes/custom/adoption_management/assets/icons/star.svg');
      }
    });
  });

  jQuery('body').on('mouseleave', '.bot-rating:not(.disabled) .stars, .bot-rating:not(.disabled)', function () {
    jQuery(this).find('.star').each(function () {
      const img = jQuery(this).find('img');
      if (jQuery(this).hasClass('selected')) {
        img.attr('src', '/themes/custom/adoption_management/assets/icons/star-clicked.svg');
      } else {
        img.attr('src', '/themes/custom/adoption_management/assets/icons/star.svg');
      }
    });
  });

  jQuery('body').on('click', '.bot-rating:not(.disabled) .star', async function () {
    const $ratingBlock = jQuery(this).closest('.bot-rating');
    const selected = jQuery(this).data('value');

    jQuery(this).parent().find('.star').each(function () {
      const thisVal = jQuery(this).data('value');
      const img = jQuery(this).find('img');
      if (thisVal <= selected) {
        jQuery(this).addClass('selected');
        img.attr('src', '/themes/custom/adoption_management/assets/icons/star-clicked.svg');
      } else {
        jQuery(this).removeClass('selected');
        img.attr('src', '/themes/custom/adoption_management/assets/icons/star.svg');
      }
    });

    //Blocca ulteriori interazioni e modifico stile
    $ratingBlock.removeClass('bg-white').addClass('disabled bg-gray-200');

    //Mostra messaggio di conferma
    $ratingBlock.find('.rating-result').text(`Hai valutato ${selected} stelle!`);

    try {
      await continueChat(selected);
    } catch (err) {
      console.error('Errore invio valutazione', err);
    } finally {
      setSessionId(null)
    }
  });
};


export function appendChatError(error = '') {
  const template = `
    <div class="bot-error pb-2">
        ${error}
    </div>
  `
  jQuery(chatContainerSelector).append(template)
}

export function removeAnswerPlaceholder() {
  jQuery('.bot-answer-placeholder').remove();
}

//Funzione per clear della chat
export function clearChatUI() {
  jQuery(chatContainerSelector).empty();
  jQuery('.intro-message').hide();
  jQuery('#QA-banner').hide();
  toggleBtnQaDuringChat(true);
}

//render della singola interazione
export function renderInteraction(interaction) {
  //se trovo una DOMANDA la appendo
  if (interaction?.request?.message?.text) {
    appendQuestion(interaction.request.message.text)
  }

  //RISPOSTA
  appendAnswer(interaction.response,{printReviewBox: false});
}

//render della chat selezionata
function renderSelectedChat(chat) {
  //Filtra risposte e per ognuna restitusice oggetto due chiavi, request e response
  const filteredInteractions = filterChatUserMessages(chat.interactions)

  currentPage = chat.page
  totalPages = chat.total_pages

  // fa reverse perché nella response le interazioni sono restituite dalla più recente alla più vecchia.
  // Siccome il codice appende uno sotto l'altro i messaggi, fa reverte dell'array
  filteredInteractions.reverse().forEach(int => {
    renderInteraction(int)
  })
  scrollChatToBottom()
  if (currentPage < totalPages) prependLoadNextChatPageBtn();
}

function filterChatUserMessages(interactions = []) {
  let filteredChats = []

  for (const chat of interactions) {
    // filtra le chiamate con next fatte per ricaricare bot
    if (chat?.request?.message?.text === 'next') continue;

    // response in cui appende recensione
    const parsedResponse = parseBotResponse(chat?.response)
    if (parsedResponse.choices && parsedResponse.choices.length > 0) continue;

    // response dopo recensione non ha clientSideActions e Messages
    if (chat?.response?.messages?.length === 0 && chat?.response?.clientSideActions?.length === 0) continue;

    filteredChats.push({
      request: chat.request,
      response: parsedResponse
    })
  }
  return filteredChats
}

export async function loadSelectedChat(id) {
  const DRAFT_CHAT_ID = '__DRAFT__';
  try {
    //mostro il loader
    showChatLoader();
    //reset sessione
    resetSessionState({isDraft: false})
    jQuery(`[data-chat-id="${DRAFT_CHAT_ID}"]`).remove();

    let chat = null


    if (isMockModeEnabled) {
      await sleep(2000)
      chat = mockHistoryDetail
    }else {
      //get della chat
      chat= await getChatDetail(id);
    }

    //rimuovo il loader
    hideChatLoader();

    //return se non trovo niente
    if (!chat || !Array.isArray(chat.interactions) || chat == {}){
      appendChatError('Si è verificato un errore. Aggiornare la pagina e riprovare');
      return;
    }
    setChatId(id);

    //render della chat
    renderSelectedChat(chat);

    selectChatInHistory(id);
    focusTextInput()

  } catch (error) {
    hideChatLoader();
    appendChatError('Si è verificato un errore. Aggiornare la pagina e riprovare');
    console.error(error);
  }
}

export function openDraftChat() {
  scrollChatHistoryToTop();

  clearChatUI();

  resetSessionState();

  prependDraftChatToHistory();
  jQuery('.intro-message').fadeIn();
  jQuery('#QA-banner').fadeIn();
  toggleBtnQaDuringChat(false);
  focusTextInput();
}


function showChatLoader() {
  jQuery('#chat-loading').removeClass('hidden');
  jQuery('.intro-message').hide();
  jQuery('.chat-container').hide();
  jQuery('.home-chatbot-block__input').removeClass('ready').hide();
  jQuery('#mrBrain-chat-container').removeClass('lg:px-20 justify-end').addClass('justify-center');
  jQuery('#QA-banner').hide();
  toggleBtnQaDuringChat(true);
}

function hideChatLoader() {
  jQuery('#chat-loading').addClass('hidden');
  jQuery('.chat-container').empty().show();
  jQuery('.home-chatbot-block__input').show();
  jQuery('#mrBrain-chat-container').addClass('lg:px-20 justify-end').removeClass('justify-center');
  jQuery('#chatbot-input').val('');
  focusTextInput();
}

export function replaceDraftHtml(realChatId , chatTitle ) {
  //tolgo gli spazi e prendo le prime 3 parole
  const messagePreview = chatTitle;
  const DRAFT_CHAT_ID = '__DRAFT__';
  const $container = jQuery('#history-list, #history-list-mobile');
  const $draftElement = $container.find(`[data-chat-id="${DRAFT_CHAT_ID}"]`);
  if (!$draftElement.length) {return}

  const newChatHtml = generateHistoryItem(messagePreview, realChatId)

  //rimpiazzo l'html e seleziono item
  $draftElement.replaceWith(newChatHtml);
}

export function showRecordButton(visible) {
  const $button = jQuery('#voice-record');
  if (!visible) {
    $button.addClass('hidden');
  } else {
    $button.removeClass('hidden');
  }
}

export function disableRecordButton() {
  const $button = jQuery('#voice-record');
  $button.addClass("pointer-events-none opacity-50")
}

export function enableRecordButton() {
  const $button = jQuery('#voice-record');
  $button.removeClass("pointer-events-none opacity-50")
}

function scrollChatHistoryToTop() {
  jQuery('#history-list').animate({
    scrollTop: 0
  }, 300);
}

export function scrollChatToLastAnswer(offset = 0) {
  const $container = jQuery('#scrollable-chat-container');
  const $target = jQuery('.bot-answer').last();

  $container.animate({
    scrollTop: $target.offset().top - $container.offset().top + $container.scrollTop() - $target.scrollTop() - offset
  }, 500);

}

export function scrollChatToElement(targetSelector, options = {offset: 0, duration: 500}) {
  const $container = jQuery('#scrollable-chat-container');
  const $target = jQuery(targetSelector).last();

  $container.animate({
    scrollTop: $target.offset().top - $container.offset().top + $container.scrollTop() - $target.scrollTop() - options.offset
  }, options.duration);

}
export function scrollChatToBottom() {
  const $container = jQuery('#scrollable-chat-container');

  $container.animate({
    scrollTop: $container[0].scrollHeight
  }, 500);
}

function prependLoadNextChatPageBtn() {
  const loadMoreBtn = `
    <div class="load-more-btn-wrapper flex justify-center py-2 h-10">
        <button type="button" class="chat-load-more text-sm font-semibold flex items-center gap-3">Carica altro</button>
    </div>
  `

  jQuery(chatContainerSelector).prepend(loadMoreBtn)
}

async function loadNextPageChatHistory() {
  try {
    let chat
    if (isMockModeEnabled) {
      await sleep(2000)
      chat = mockHistoryDetail
    }else {
      //get della chat
      chat= await getChatDetail(id, {page: currentPage + 1});
    }

    //Filtra risposte e per ognuna restitusice oggetto due chiavi, request e response
    const filteredInteractions = filterChatUserMessages(chat.interactions)

    currentPage = chat.page
    totalPages = chat.total_pages

    filteredInteractions.forEach((int, i) => {
      const interactionId = `interaction-${currentPage}${i}`
      renderPreviuosInteraction(int, interactionId)
    })

    if (currentPage < totalPages) prependLoadNextChatPageBtn();
    scrollChatToElement(`[id*=interaction-${currentPage}]`, {offset: 30, duration: 0})

  } catch(error) {
    showErrorToast('Si è verificato un errore. Aggiornare la pagina e riprovare');
    console.error(error);
  }

}

function renderPreviuosInteraction(interaction, intId) {
  // crea contenitore per l'interazione che viene preposto alla chat, dentro vengono stampati domanda e risposta
  const containerSelector = `#${intId}`

  jQuery(chatContainerSelector).prepend(`<div id="${intId}" class="flex flex-col gap-5"></div>`)

  if (interaction?.request?.message?.text) {
    appendQuestion(interaction.request.message.text, {targetContainer: containerSelector})
  }
  appendAnswer(interaction.response,{printReviewBox: false, targetContainer: containerSelector});

}